<template>
    <div class="conversations-container flex-grow-1 flex-shrink-0 position-relative">
      <div class="position-absolute h-100 w-100 d-flex flex-column">
        <filter-component
            :list="filterList"
            :values="filters"
            @apply="onFiltersApply"
            class="flex-grow-0 flex-shrink-0 mb-2"
        >
          <template v-slot:buttons>
            <button class="btn btn-purple align-self-start ml-1" @click="refreshList">
              <i class="fas fa-sync" v-bind:class="{'fa-spin': isListRefreshingActive}"></i>
            </button>
            <button
              class="btn btn-purple align-self-start ml-1"
              @click="onAddToGroup"
              v-if="canAddToGroup"
            >
              Add to group
            </button>
          </template>
        </filter-component>
        <el-input
            v-model="pendingSearch"
            @input="onPendingSearchChanged"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="flex-grow-0 flex-shrink-0 search-bar mb-2"
        ></el-input>
        <list
            ref="list"
            :url="url"
            @conversation-select="onSelect"
            @refresh-start="onListRefreshStarted"
            @refresh-finish="onListRefreshFinished"
            class="list flex-grow-1"
        ></list>
        <add-to-group-dialog-form-wrapper v-if="canAddToGroup"></add-to-group-dialog-form-wrapper>
      </div>
    </div>
</template>

<script>
  import List from './list';
  import AutoHeight from '../auto-height';
  import UrlFilterService from '../../services/url-filter-service';
  import Filter from '../filter/v1/index';
  import eventBus from '../../event-bus';
  import AddToGroupDialogFormWrapper from "./send-list/dialog-form-wrapper";

  export default {
    props: {
      filterList: Array,
      delay: {
        type: Number,
        default: 700,
      },
      refreshInterval: {
        type: Number,
        default: 30000,
      },
      addToGroupProps: Object,
    },

    data() {
      return {
        filters: {},
        url: null,
        urlService: null,
        current: null,
        pendingSearch: null,
        debouncedSearchApply: _.debounce(function () {
          const searchFilter = this.pendingSearch ? {search: this.pendingSearch} : {};
          this.filters = _.assign({}, _.omit(this.filters, 'search'), searchFilter);
          this.applyFilters();
        }, this.delay),
        isListRefreshingActive: false,
        refreshTimerId: null,
      };
    },

    computed: {
      /**
       * @return {String|null}
       */
      search() {
        return this.filters.search || null;
      },

      /**
       * @return {boolean}
       */
      canAddToGroup() {
        return Boolean(_.get(this.addToGroupProps, 'canAddToGroup', false));
      },

      /**
       * @return {String}
       */
      getAddToGroupIndexUrl() {
        return _.get(this.addToGroupProps, 'indexUrl');
      },
    },

    watch: {
      search(val) {
        this.pendingSearch = this.search;
      },

      url(val) {
        eventBus.$emit('url-change', val);
      },
    },

    methods: {
      /**
       * @param {String} value
       */
      onPendingSearchChanged(value) {
        this.debouncedSearchApply();
        if (_.size(value) === 0) {
          this.debouncedSearchApply.flush();
        }
      },

      /**
       * @return {undefined}
       */
      applyFilters() {
        this.url = this.urlService.updateUrl(this.filters);
      },

      /**
       * @param {Object} conversation
       */
      onSelect(conversation) {
        this.current = conversation;
        this.$emit('change', conversation);
      },

      /**
       * @param {Object} value
       */
      onFiltersApply(value) {
        this.filters = _.assign({}, value);
        this.applyFilters();
      },

      /**
       * @return {undefined}
       */
      initializeFilters() {
        const filterNames = _.map(this.filterList, item => item.name);
        this.urlService = new UrlFilterService(filterNames);
        this.filters = this.urlService.getFilters();
      },

      /**
       * @return {undefined}
       */
      refreshList() {
        this.$refs.list.silentRefresh();
      },

      /**
       * @return {undefined}
       */
      onListRefreshStarted() {
        this.isListRefreshingActive = true;
      },

      /**
       * @return {undefined}
       */
      onListRefreshFinished() {
        this.isListRefreshingActive = false;
      },

      /**
       * @param {Number} brandId
       * @param {Number} contactId
       * @param {Object|null} model
       */
      contactNoteStored({brandId, contactId, model}) {
        this.$refs.list.contactNoteStored({brandId, contactId, model});
      },

      /**
       * @param {Number} conversationId
       * @param {Object} model
       */
      onContactStored({conversationId, model}) {
        this.$refs.list.contactStored({conversationId, model});
      },

      /**
       * @param {Number} conversationId
       * @param {Object|null} list
       */
      scheduleListChanged({conversationId, list = null}) {
        this.$refs.list.scheduleListChanged({conversationId, list});
      },

      /**
       * @emits show-add-to-group-dialog
       */
      onAddToGroup() {
        eventBus.$emit('show-add-to-group-dialog', this.getAddToGroupIndexUrl);
      },
    },

    created() {
      this.initializeFilters();
    },

    mounted() {
      this.url = this.urlService.url;
      this.refreshTimerId = setInterval(this.refreshList, this.refreshInterval);
    },

    beforeDestroy() {
      clearInterval(this.refreshTimerId);
    },

    components: {
      List,
      AutoHeight,
      FilterComponent: Filter,
      AddToGroupDialogFormWrapper,
    }
  }
</script>
